export default __webpack_public_path__ + "static/media/Beast Hunter's Malice Breaker.0f58d8a0.jpg";